import {useEffect} from "react";
import {Column, Line} from "components";
import {Box, Users} from "react-feather";
import {get} from "global/slices/home/thunks";
import {useAppDispatch, useAppSelector} from "hooks";
import {ApprovedLoans, GroupItem, LoanApplications} from "./lib";
import {
  WalletOutlined,
  ArticleOutlined,
  CreditScoreOutlined,
  CreditCardOutlined,
} from "@mui/icons-material";

interface HomeProps {}

export const Home: React.FC<HomeProps> = () => {
  const dispatch = useAppDispatch();
  const {charts} = useAppSelector("home");
  const {
    totalClientes,
    montoFinanzas,
    totalProductos,
    montoCobranzas,
    totalFormularios,
    montoPaymentReports
  } = charts;
  useEffect(() => {
    dispatch(get());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Column>
      <GroupItem
        title="Estadísticas"
        data={[
          {
            icon: ArticleOutlined,
            value: totalFormularios,
            label: "Total Formularios",
          },
          {
            icon: Users,
            value: totalClientes,
            label: "Total Clientes",
          },
          {
            icon: Box,
            value: totalProductos,
            label: "Total Productos",
          },
          {
            icon: CreditScoreOutlined,
            value: `${Number(montoFinanzas).toLocaleString("US")}`,
            label: "Finanzas",
          },
          {
            icon: WalletOutlined,
            value: `${Number(montoCobranzas).toLocaleString("US")}`,
            label: "Cobranza",
          },
          {
            icon: CreditCardOutlined,
            value: `${Number(montoPaymentReports).toLocaleString("US")}`,
            label: "Pagos reportados",
          },
        ]}
      />
      <ApprovedLoans />
      <Line />
      <LoanApplications />
    </Column>
  );
};
